export default {
    "en": {
        "articles": {
            "add": "Add address",
            "edit": "Edit address",
            "delete": "Delete address",
            "not_find": "Can not find a address with this code.",
            "id": "Id",
            "created_at": "Created at",
            "report_title": "Address Report"
        },
        "auth": {
            "failed": "These credentials do not match our records.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "customers": {
            "add": "Add customer",
            "edit": "Edit customer",
            "delete": "Delete customer",
            "not_find": "Can not find a client with this code.",
            "id": "Id",
            "contact": "Contact",
            "contact_placeholder": "Enter the customer's contact",
            "address": "Address",
            "address_placeholder": "Enter the customer's address",
            "state": "State",
            "state_placeholder": "Enter the state",
            "phone": "Phone",
            "phone_placeholder": "Enter the customer's phone",
            "email": "Email",
            "email_placeholder": "Enter the customer's email",
            "created_at": "Created at",
            "report_title": "Customers Report"
        },
        "doctors": {
            "name": "Name",
            "email": "Email",
            "phone_number": "Phone",
            "account_clabe": "Account",
            "bank": "Bank",
            "status": "Status",
            "report_title": "Reporte de Doctores"
        },
        "errors": {
            "fatal_error": "A fatal error occurred, please contact us.",
            "generic_error": "An error occurred, please try again.",
            "unauthorized": "Unauthorized.",
            "forbidden": "Forbidden.",
            "connection_error": "Connection error",
            "action_unauthorized": "This action is unauthorized."
        },
        "feedback": {
            "rate": "What do you think of this experience?",
            "comment": "Tell us how was your experience?",
            "contact_me": "Controlla can contact me about my feedback."
        },
        "front": {
            "added_successfully": "It has been added successfully.",
            "updated_successfully": "It has been updated successfully.",
            "deleted_successfully": "It has been deleted successfully.",
            "imported_successfully": "It has been imported successfully.",
            "delete_modal": "Delete",
            "delete_confirmation": "Are you sure you want to delete the {model} {attribute}?",
            "delete_confirmation2": "Are you sure you want to delete {model} {attribute}?",
            "action_confirmation": "Are you sure you want to {action} this {model}?",
            "action_confirmation2": "Are you sure you want to {action} this {model}?",
            "import_modal": "Import {model} from CSV or Excel file"
        },
        "login": {
            "email": "Email",
            "password": "Password",
            "keep_connected": "Keep connected",
            "forgot_password": "Forgot password",
            "login": "Login",
            "logout": "Logout",
            "reset_password": "Reset password",
            "send_reset_link": "Send the reset link",
            "password_confirmation": "Password confirmation",
            "still_having_trouble": "Still having trouble logging in?",
            "havent_account": "Don't have a account?",
            "back_login": "Back to login",
            "register": "Create account",
            "welcome": "Welcome",
            "description": "Description app"
        },
        "notifications": {
            "empty_title": "No notifications at this time",
            "empty_msg": "When your team starts doing things, we will show the notifications here.",
            "add_new_user": "New User!",
            "add_new_user_message": "has added a new user"
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "passwords": {
            "password": "Passwords must be at least six characters and match the confirmation.",
            "reset": "Your password has been reset!",
            "code_succesfully": "Su código ha sido validado exitosamente.",
            "code_failed": "The code your provided is wrong. Please try again or request another call.",
            "resend_code_succesfully": "Su código ha sido reenviado exitosamente.",
            "send_code_succesfully": "Hemos enviado a su telefono el código para restablecer su contraseña!",
            "send_succesfully": "Hemos enviado por correo electrónico el enlace para restablecer su contraseña!",
            "send_failed": "Ocurrio un error al restablecer su contraseña!",
            "phone_not_found": "No se encontro le numero de telefono en nuestros registros",
            "sent": "We have e-mailed your password reset link!",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that e-mail address.",
            "cant_login": "Can't you login?",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "patient": {
            "name": "Nombre",
            "email": "Correo",
            "phone_number": "Telefono",
            "status": "Estatus",
            "report_title": "Report Patient"
        },
        "purchase_orders": {
            "add": "Add purchase order",
            "edit": "Edit purchase order",
            "delete": "Delete purchase order",
            "not_find": "Can not find a purchase order with this code.",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Enter the purchase order's folio",
            "created_at": "Created at",
            "report_title": "Purchase Orders Report"
        },
        "register": {
            "title": "Sign up to get your account",
            "email": "Email",
            "name": "Username",
            "password": "Password",
            "register": "Create account",
            "message": "By registering, confirm that you have read and accepted our  <a href=\"/login\"> Terms of use </a> and our <a href=\"/login\"> Privacy policy </a>.",
            "back_login": "Already have an Controlla account? Log in",
            "very_weak": "Very weak",
            "weak": "Weak",
            "good": "Good",
            "strong": "Strong",
            "very_strong": "Very strong"
        },
        "reset": {
            "subject": "Reset your Controlla Password",
            "line_1": "You are receiving this email because we received a password reset request for your account.",
            "action": "Reset Password",
            "line_2": "This password reset link will expire in {count} minutes.",
            "line_3": "If you did not request a password reset, no further action is required."
        },
        "strings": {
            "dashboard": "Dashboard",
            "overview": "Overview",
            "user": "User",
            "users": "Users",
            "customer": "Customer",
            "customers": "Customers",
            "quotation": "Quotation",
            "quotations": "Quotations",
            "quotation_detail": "Quotation Detail",
            "quotation_details": "Quotation Details",
            "purchase_order": "Purchase Order",
            "purchase_orders": "Purchase Orders",
            "welcome": "Welcome back! See everything that's going on in your app.",
            "new_users": "new this week",
            "type_service": "Type of service",
            "sub_type_services": "Users who use active services within the app.",
            "earnings": "Your earnings this month",
            "see_earnings": "See all profits",
            "services_earnings": "Earnings per service",
            "users_counts": "Registered users",
            "prof_counts": "Registered professionalists",
            "description": "An Overview of your {attribute}",
            "search": "Search {attribute} by{columns} or {column}",
            "filters": "Filters",
            "clear": "Clear",
            "apply": "Apply",
            "select_date": "Select a date",
            "multiple": "Multiple",
            "display_list": "Display list",
            "display_grid": "Display grid (enabled)",
            "print": "Print",
            "delete": "Delete",
            "add": "Add",
            "addDetail": "Add Detail",
            "edit": "Edit",
            "save": "Save",
            "accept": "Accept",
            "cancel": "Cancel",
            "view": "View",
            "import": "Import",
            "registered_on": "Registered on",
            "order_by": "Order by",
            "options": "More options",
            "notifications": "Notifications",
            "messages": "Messages",
            "no_notifications": "No notifications",
            "no_messages": "No messages",
            "see_all": "See all",
            "exit": "Exit",
            "feedback": "Feedback",
            "give_feedback": "Give feedback",
            "shortcuts": "Shortcuts",
            "close_modal": "Close modal",
            "create": "Create resource",
            "view_selected": "View selected",
            "edit_selected": "Edit selected",
            "view_notifications": "View notifications",
            "find": "find",
            "register": "Register",
            "cancelled": "Cancelled",
            "sold": "Sold",
            "invoiced": "Invoiced",
            "paid": "Paid",
            "pending": "Pending",
            "approved": "Approved",
            "received": "Received",
            "send": "Sent",
            "action_sold": "Sell",
            "action_invoiced": "Invoice",
            "action_paid": "Pay",
            "action_approved": "Approved",
            "action_received": "Received",
            "action_send": "Send",
            "action_active": "Active",
            "action_inactive": "Inactive",
            "doctors": "Doctors",
            "patient": "Patient",
            "range_dates": "Select a date range"
        },
        "users": {
            "add": "Add user",
            "edit": "Edit user",
            "delete": "Delete user",
            "not_find": "Can not find user with this code.",
            "actived_error": "User is already active",
            "inactived_error": "User is already inactive",
            "actived": "User has been activated",
            "inactived": "User has been inactivated",
            "active": "Active",
            "inactive": "Inactive",
            "id": "Id",
            "name": "Name",
            "name_placeholder": "Enter the user's name",
            "email": "Email",
            "email_placeholder": "Enter the user's email",
            "password": "Password",
            "password_placeholder": "Enter the user's password",
            "confirm_password": "Confirm Password",
            "confirm_password_placeholder": "Enter the user's confirm password",
            "role": "Role",
            "role_placeholder": "Enter the user's role",
            "status": "Status",
            "leave_empty": "Leave empty to keep the current password",
            "created_at": "Created at",
            "report_title": "Users Report"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal {value}.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "string": "The {attribute} must be less than or equal {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "present": "The {attribute} field must be present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": []
        },
        "verification": {
            "title": "Verify your Email Address",
            "check_email": "Check the inbox to finish the registration.",
            "check_email_label": "Check the email to finish the registration. We have sent you a registration link to the address:",
            "resend_email": "You have not received the registration link? Resend",
            "resend_succesfully": "Successfully resend",
            "reset_email": "Change email address",
            "This is your verification code. {code}.": "This is your verification code. {code}.",
            "The code your provided is wrong. Please try again or request another code.": "The code your provided is wrong. Please try again or request another code.",
            "Your phone has not been verified yet": "Your phone has not been verified yet",
            "Your phone was successfully verified!": "Your phone was successfully verified!",
            "Your code has been resent successfully.": "Your code has been resent successfully."
        },
        "welcome": {
            "subject": "Welcome to Controlla",
            "line_1": "Welcome to controlla.",
            "action": "Start now"
        }
    },
    "es": {
        "This is your verification code. {code}.": "Expert Salud: Este es tu código de verificación. {code}.",
        "The code your provided is wrong. Please try again or request another code.": "El código que proporcionó es incorrecto. Por favor intente nuevamente o solicite otro código.",
        "Your phone has not been verified yet": "Su teléfono no ha sido verificado aún",
        "Your phone was successfully verified!": "Su teléfono fue verificado con éxito!",
        "Your code has been resent successfully.": "Su código ha sido reenviado exitosamente.",
        "articles": {
            "add": "Agregar dirección",
            "edit": "Editar dirección",
            "delete": "Eliminar Dirección",
            "not_find": "No se puede encontrar un dirección con este código.",
            "id": "Id",
            "created_at": "Creado en",
            "report_title": "Reporte de Direcciones"
        },
        "auth": {
            "failed": "Estas credenciales no coinciden con nuestros registros.",
            "throttle": "Demasiados intentos de inicio de sesión. Por favor intente de nuevo en {seconds} segundos."
        },
        "certifications": {
            "add": "Agregar servicio",
            "edit": "Editar servicio",
            "delete": "Eliminar servicio",
            "not_find": "No se puede encontrar un servicio con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El servicio se ha activado",
            "inactived": "El servicio se ha inactivado",
            "id": "Id",
            "hp_profile": "Profesional",
            "hp_profile_placeholder": "Ingresa el profesional del servicio",
            "curp": "Curp",
            "curp_placeholder": "Ingresa el curp del servicio",
            "status": "Estatus",
            "status_placeholder": "Ingresa el estatus del servicio",
            "account_status_file": "Estado de cuenta",
            "identification_file": "Identificacion oficial",
            "date": "Fecha",
            "certified_at": "Fecha de certificacion",
            "created_at": "Creado en",
            "report_title": "Reporte de pagos a Doctores",
            "commision_title": "Reporte de comisiones",
            "expert_commission": "Comisiones"
        },
        "charges": {
            "add": "Agregar servicio",
            "edit": "Editar servicio",
            "delete": "Eliminar servicio",
            "not_find": "No se puede encontrar un servicio con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El servicio se ha activado",
            "inactived": "El servicio se ha inactivado",
            "active": "Activo",
            "inactive": "Inactivo",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Ingresa el folio del servicio",
            "date": "Fecha",
            "date_placeholder": "Ingresa la fecha del servicio",
            "status": "Estatus",
            "status_placeholder": "Ingresa el status del servicio",
            "expert_commission": "Comisiones",
            "conekta_commission": "Comisión Conekta",
            "twilio_commission": "Comisión Twilio",
            "service_amount": "Monto del servicio",
            "total_amount": "Monto total",
            "amount_placeholder": "Ingresa el monto del servicio",
            "payment_folio": "Folio de pago",
            "payment_method_id": "Metodo de pago",
            "user_id": "Cliente",
            "doctor_names": "Doctor",
            "bank": "Banco",
            "account": "Cuenta",
            "total": "Total",
            "hp_user_id": "Profesional",
            "profile_id": "Cliente",
            "hp_profile_id": "Profesional",
            "call": "Llamada",
            "chat": "Chat",
            "diary": "Consulta",
            "card": "Tarjeta",
            "electronic": "Dinero Electronico",
            "free": "Gratuito",
            "service_type_id": "Tipo de Servicio",
            "speciality": "Especialidad",
            "already_accepted": "Este servicio ya fue aceptado.",
            "already_declined": "Este servicio ya fue rechazado.",
            "already_canceled": "Este servicio ya fue cancelado.",
            "created_at": "Creado en",
            "report_title": "Reporte de pagos a Doctores",
            "commision_title": "Reporte de comisiones"
        },
        "customers": {
            "add": "Agregar cliente",
            "edit": "Editar cliente",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un cliente con este código.",
            "id": "Id",
            "contact": "Contacto",
            "contact_placeholder": "Ingresa el contacto del cliente",
            "address": "Dirección",
            "address_placeholder": "Ingresa la dirección del cliente",
            "state": "Estado",
            "state_placeholder": "Ingresa el estado",
            "phone": "Teléfono",
            "phone_placeholder": "Ingresa el teléfono del cliente",
            "email": "Correo electrónico",
            "email_placeholder": "Ingresa el correo del cliente",
            "created_at": "Creado en",
            "report_title": "Reporte de Clientes"
        },
        "doctors": {
            "name": "Nombre",
            "email": "Correo",
            "phone_number": "Telefono",
            "account_clabe": "Clabe bancaria",
            "bank": "Banco",
            "status": "Estatus",
            "report_title": "Reporte de Doctores"
        },
        "errors": {
            "fatal_error": "Se produjo un error fatal, póngase en contacto con nosotros.",
            "generic_error": "Ha ocurrido un error. Por favor intente de nuevo.",
            "unauthorized": "Credenciales incorrectas. Por favor intente de nuevo.",
            "connection_error": "Error de conexión",
            "action_unauthorized": "No estas autorizado para realizar esta acción",
            "sep_service_unavailable": "La validación de cedulas de la SEP no esta disponible."
        },
        "feedback": {
            "rate": "¿Como te parece este sistema?",
            "comment": "¿Cuéntanos cómo ha sido tu experiencia?",
            "contact_me": "Controlla puede comunicarse conmigo en relación con mis comentarios."
        },
        "front": {
            "added_successfully": "Ha sido agregado con éxito.",
            "updated_successfully": "Ha sido actualizado con éxito.",
            "deleted_successfully": "Ha sido eliminado con éxito.",
            "imported_successfully": "Ha sido importado con éxito.",
            "delete_modal": "Eliminar",
            "delete_confirmation": "¿Seguro que quieres eliminar la {model} {attribute}?",
            "delete_confirmation2": "¿Seguro que quieres eliminar el {model} {attribute}?",
            "action_confirmation": "¿Seguro que deseas {action} esta {model}?",
            "action_confirmation2": "¿Seguro que deseas {action} este {model}?",
            "import_modal": "Importar {model} desde un archivo CSV o Excel"
        },
        "login": {
            "email": "Correo electrónico",
            "password": "Contraseña",
            "keep_connected": "Recordarme",
            "forgot_password": "Restablecer",
            "login": "Iniciar sesión",
            "logout": "Cerrar sesión",
            "reset_password": "Restablecer la contraseña",
            "send_reset_link": "Enviar el enlace de reinicio",
            "password_confirmation": "Confirmación de contraseña",
            "still_having_trouble": "¿Sigues teniendo problemas para iniciar sesión?",
            "havent_account": "No tienes una cuenta?",
            "back_login": "Volver a Inicio de sesión",
            "register": "Crear cuenta",
            "welcome": "Bienvenido",
            "description": "Descripción"
        },
        "notifications": {
            "empty_title": "No hay notificaciones en este momento",
            "empty_msg": "Cuando tu equipo empiece a hacer cosas, mostraremos las notificaciones aquí.",
            "add_new_user": "Usuario Nuevo!",
            "add_new_user_message": "agrego un nuevo usuario"
        },
        "pagination": {
            "previous": "« Previous",
            "next": "Next »"
        },
        "passwords": {
            "password": "Las contraseñas deben tener al menos seis caracteres y coincidir con la confirmación.",
            "reset": "¡Tu contraseña ha sido restablecida!",
            "code_succesfully": "Su código ha sido validado exitosamente.",
            "code_failed": "El código que proporcionaste es incorrecto. Vuelva a intentarlo o solicite otro código.",
            "resend_code_succesfully": "Su código ha sido reenviado exitosamente.",
            "send_code_succesfully": "Hemos enviado a su telefono el código para restablecer su contraseña!",
            "send_succesfully": "Hemos enviado por correo electrónico el enlace para restablecer su contraseña!",
            "send_failed": "Ocurrio un error al restablecer su contraseña!",
            "phone_not_found": "No se encontro el número de telefono en nuestros registros",
            "sent": "Hemos enviado por correo electrónico el enlace para restablecer su contraseña!",
            "token": "Este token de restablecimiento de contraseña no es válido.",
            "user": "No podemos encontrar un usuario con esa dirección de correo electrónico.",
            "cant_login": "¿No puedes iniciar sesión?",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "patient": {
            "name": "Nombre",
            "email": "Correo",
            "phone_number": "Telefono",
            "status": "Estatus",
            "report_title": "Reporte de Pacientes"
        },
        "payments": {
            "add": "Agregar pago",
            "edit": "Editar pago",
            "delete": "Eliminar pago",
            "not_find": "No se puede encontrar un pago con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El pago se ha activado",
            "inactived": "El pago se ha inactivado",
            "active": "Activo",
            "inactive": "Inactivo",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Ingresa el folio del pago",
            "date": "Fecha",
            "date_placeholder": "Ingresa la fecha del pago",
            "status": "Status",
            "status_placeholder": "Ingresa el status del pago",
            "amount": "Monto",
            "amount_placeholder": "Ingresa el monto del pago",
            "conekta_commission": "Comisión Conekta",
            "user_id": "Usuario",
            "created_at": "Creado en",
            "report_title": "Reporte de Pagos"
        },
        "profiles": {
            "add": "Agregar usuario",
            "edit": "Editar usuario",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un usuario con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El usuario se ha activado",
            "inactived": "El usuario se ha inactivado",
            "active": "Activo",
            "inactive": "Inactivo",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del usuario",
            "email": "Correo",
            "email_placeholder": "Ingresa el correo electrónico del usuario",
            "password": "Contraseña",
            "password_placeholder": "Ingresa la contraseña del usuario",
            "confirm_password": "Confirma Contraseña",
            "confirm_password_placeholder": "Confirma la contraseña del usuario",
            "role": "Rol",
            "role_placeholder": "Ingresa el rol del usuario",
            "status": "Estatus",
            "leave_empty": "Dejar vacío para mantener la contraseña actual.",
            "last_login": "Ultima conexion",
            "hp_unavailable": "Profesional de la salud no disponible",
            "created_at": "Creado en",
            "report_title": "Reporte de Usuarios"
        },
        "purchase_orders": {
            "add": "Agregar orden de compra",
            "edit": "Editar orden de compra",
            "delete": "Eliminar orden de compra",
            "not_find": "No se puede encontrar una orden de compra con este código.",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Ingresa el folio de la orden de compra",
            "created_at": "Creado en",
            "report_title": "Reporte de Ordenes de Compra"
        },
        "register": {
            "title": "Regístrate para obtener tu cuenta",
            "email": "Correo electrónico",
            "name": "Nombre de usuario",
            "password": "Contraseña",
            "register": "Crear cuenta",
            "message": "Al registrarte, confirmas que has leído y aceptado nuestros <a href=\"/login\" class=\"content-vertical text-secondary\"> Términos de uso</a> y nuestra <a href=\"/login\"> Política de privacidad</a>.",
            "back_login": "¿Ya tienes una cuenta de Controlla? Iniciar sesión",
            "very_weak": "Débil",
            "weak": "Normal",
            "good": "Buena",
            "strong": "Sólida",
            "very_strong": "Muy Sólida"
        },
        "reports": {
            "add": "Agregar reporte",
            "edit": "Editar reporte",
            "delete": "Eliminar reporte",
            "not_find": "No se puede encontrar un reporte con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El reporte se ha activado",
            "inactived": "El reporte se ha inactivado",
            "active": "Activo",
            "inactive": "Inactivo",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Ingresa el folio del reporte",
            "amount": "Monto",
            "amount_placeholder": "Ingresa el monto del reporte",
            "date": "Fecha",
            "openpay_commission": "Comision Coneckta",
            "expert_commission": "Comision Expert",
            "created_at": "Creado en",
            "report_titleD": "Pagos de  Doctores"
        },
        "reset": {
            "subject": "Restablece tu contraseña de Controlla",
            "line_1": "Recibió este correo electrónico porque recibimos una solicitud de restablecimiento de contraseña para su cuenta.",
            "action": "Restablecer contraseña",
            "line_2": "Este enlace de restablecimiento de contraseña caducará en {count} minutos.",
            "line_3": "Si no solicitó un restablecimiento de contraseña, no se requiere ninguna otra acción."
        },
        "services": {
            "add": "Agregar servicio",
            "edit": "Editar servicio",
            "delete": "Eliminar servicio",
            "not_find": "No se puede encontrar un servicio con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El servicio se ha activado",
            "inactived": "El servicio se ha inactivado",
            "active": "Activo",
            "inactive": "Inactivo",
            "id": "Id",
            "folio": "Folio",
            "folio_placeholder": "Ingresa el folio del servicio",
            "date": "Fecha",
            "date_placeholder": "Ingresa la fecha del servicio",
            "status": "Estatus",
            "status_placeholder": "Ingresa el status del servicio",
            "expert_commission": "Comisiones",
            "conekta_commission": "Comisión Conekta",
            "twilio_commission": "Comisión Twilio",
            "service_amount": "Monto del servicio",
            "amount": "Monto",
            "amount_placeholder": "Ingresa el monto del servicio",
            "payment_folio": "Folio de pago",
            "payment_method": "Metodo de pago",
            "user_id": "Cliente",
            "doctor_names": "Doctor",
            "bank": "Banco",
            "account": "Cuenta",
            "total": "Total",
            "hp_user_id": "Profesional",
            "profile_id": "Cliente",
            "formula_constant": "Constante de la Formula",
            "hp_profile_id": "Profesional",
            "call": "Llamada",
            "chat": "Chat",
            "diary": "Consulta",
            "card": "Tarjeta",
            "electronic": "Dinero Electronico",
            "free": "Gratuito",
            "service_type": "Tipo de Servicio",
            "speciality": "Especialidad",
            "already_accepted": "Este servicio ya fue aceptado.",
            "already_declined": "Este servicio ya fue rechazado.",
            "already_canceled": "Este servicio ya fue cancelado.",
            "created_at": "Creado en",
            "report_title": "Reporte de pagos a Doctores",
            "commision_title": "Reporte de comisiones"
        },
        "strings": {
            "dashboard": "Inicio",
            "overview": "Inicio",
            "users": "Usuarios",
            "user": "Usuario",
            "customer": "Cliente",
            "customers": "Clientes",
            "quotation": "Cotización",
            "quotations": "Cotizaciones",
            "quotation_detail": "Quotation Detail",
            "quotation_details": "Quotation Details",
            "purchase_order": "Orden de Compra",
            "oc_number": "# O.C.",
            "purchase_orders": "Ordenes de Compra",
            "sale": "Venta",
            "sales": "Ventas",
            "supplier": "Proveedor",
            "suppliers": "Proveedores",
            "product": "Producto",
            "products": "Productos",
            "mining_group": "Grupo Minero",
            "mining_groups": "Grupos Mineros",
            "dashboardD": "Dashboard",
            "welcome": "¡Bienvenido de vuelta! Mira todo lo que esta pasando en tu aplicación.",
            "new_users": "nuevos esta semana",
            "type_service": "Tipo de servicio",
            "sub_type_services": "Usuarios que utilizan los servicios activos dentro de la aplicación.",
            "earnings": "Tus ganancias este mes",
            "see_earnings": "Ver todas las ganancias",
            "services_earnings": "Ganancias por servicios",
            "users_counts": "Usuarios registrados",
            "prof_counts": "Profesionales registrados",
            "description": "Un resumen de sus {attribute}",
            "search": "Buscar {attribute} por{columns} ó {column}",
            "filters": "Filtros",
            "clear": "Limpiar",
            "apply": "Aplicar",
            "select_date": "Selecciona una fecha",
            "multiple": "Selección multiple",
            "display_list": "Ver en lista",
            "display_grid": "Ver en grid (deshabilitado)",
            "print": "Imprimir",
            "delete": "Eliminar",
            "add": "Agregar",
            "addDetail": "Agregar Detalle",
            "edit": "Editar",
            "save": "Guardar",
            "accept": "Aceptar",
            "cancel": "Cancelar",
            "view": "Ver",
            "import": "Importar",
            "registered_on": "Registrado desde",
            "order_by": "Ordenado por",
            "options": "Más opciones",
            "notifications": "Notificaciones",
            "messages": "Mensajes",
            "no_notifications": "No tienes notificaciones",
            "no_messages": "No tienes mensajes",
            "see_all": "Marcar todo como leído",
            "exit": "Salir",
            "feedback": "Enviar Comentarios",
            "give_feedback": "Dar opinión",
            "shortcuts": "Atajos de teclado",
            "close_modal": "Cerrar modal",
            "create": "Crear registro",
            "view_selected": "Ver seleccionado",
            "edit_selected": "Editar seleccionado",
            "view_notifications": "Ver notificaciones",
            "find": "Buscar un registro",
            "register": "Registro",
            "service": "Servicio",
            "services": "Servicios",
            "charge": "Cargo",
            "charges": "Cargos",
            "report": "Reporte",
            "reports": "Reportes",
            "payment": "Pago",
            "payments": "Pagos",
            "commission_config": "Configurar comision",
            "certification": "Certificación",
            "certifications": "Certificaciones",
            "cancelled": "Cancelado",
            "sold": "Vendido",
            "invoiced": "Facturado",
            "paid": "Pagado",
            "pending": "Pendiente",
            "approved": "Aprobado",
            "received": "Recibido",
            "send": "Enviado",
            "certify": "Certificar",
            "reject": "Rechazar",
            "action_sold": "Pagar",
            "action_invoiced": "Facturar",
            "action_paid": "Pagar",
            "action_approved": "Aprobar",
            "action_received": "Recibir",
            "action_send": "Enviar",
            "action_active": "Activar",
            "action_inactive": "Inactivar",
            "report_doctors_paid": "Reporte \"Pago a doctores\"",
            "generate_report": "Generar Reporte",
            "report_profits": "Reporte \"Ganancias expert\"",
            "doctors": "Doctores",
            "patient": "Pacientes",
            "range_dates": "Selecciona un rango de fechas"
        },
        "users": {
            "add": "Agregar usuario",
            "edit": "Editar usuario",
            "delete": "Eliminar Cliente",
            "not_find": "No se puede encontrar un usuario con este código.",
            "actived_error": "Usuario ya activo",
            "inactived_error": "Usuario ya inactivo",
            "actived": "El usuario se ha activado",
            "inactived": "El usuario se ha inactivado",
            "active": "Activo",
            "inactive": "Inactivo",
            "id": "Id",
            "name": "Nombre",
            "name_placeholder": "Ingresa el nombre del usuario",
            "email": "Correo",
            "email_placeholder": "Ingresa el correo electrónico del usuario",
            "password": "Contraseña",
            "password_placeholder": "Ingresa la contraseña del usuario",
            "confirm_password": "Confirma Contraseña",
            "confirm_password_placeholder": "Confirma la contraseña del usuario",
            "role": "Rol",
            "role_placeholder": "Ingresa el rol del usuario",
            "status": "Estatus",
            "leave_empty": "Dejar vacío para mantener la contraseña actual.",
            "last_login": "Ultima conexion",
            "created_at": "Creado en",
            "report_title": "Reporte de Usuarios"
        },
        "validation": {
            "accepted": "El campo {attribute} debe ser aceptado.",
            "active_url": "El campo {attribute} no es una URL válida.",
            "after": "El campo {attribute} debe ser una fecha después a {date}.",
            "after_or_equal": "El campo {attribute} debe ser una fecha posterior o igual a {date}.",
            "alpha": "El campo {attribute} solo puede contener letras.",
            "alpha_dash": "El campo {attribute} solo puede contener letras, números, guiones y guiones bajos.",
            "alpha_num": "El campo {attribute} solo puede contener letras y números.",
            "array": "El campo {attribute} debe ser una matriz.",
            "before": "El campo {attribute} debe ser una fecha antes de {date}.",
            "before_or_equal": "El campo {attribute} debe ser una fecha antes o igual a {date}.",
            "between": {
                "numeric": "El {attribute} debe estar entre {min} y {max}.",
                "file": "El {attribute} debe estar entre {min} y {max} kilobytes.",
                "string": "El {attribute} debe estar entre {min} y {max} caracteres.",
                "array": "El {attribute} debe estar entre {min} y {max} artículos."
            },
            "boolean": "El campo {attribute} debe ser verdadero o falso.",
            "confirmed": "La confirmación de {attribute} no coincide.",
            "date": "La {attribute} no es una fecha valida.",
            "date_format": "La {attribute} no coincide con el formato {format}.",
            "different": "El {attribute} y {other} deben ser diferentes.",
            "digits": "El {attribute} deben ser {digits} dígitos.",
            "digits_between": "El {attribute} debe estar entre {min} y {max} dígitos.",
            "dimensions": "El {attribute} tiene dimensiones de imagen inválidas.",
            "distinct": "El {attribute} campo tiene un valor duplicado.",
            "email": "El campo {attribute} debe ser una dirección de correo electrónico válida.",
            "exists": "El {attribute} seleccionado no existe.",
            "file": "El {attribute} debe ser un archivo.",
            "filled": "El {attribute} campo debe tener un valor.",
            "gt": {
                "numeric": "El {attribute} debe ser mayor que {value}.",
                "file": "El {attribute} debe ser mayor que {value} kilobytes.",
                "string": "El {attribute} debe ser mayor que {value} caracteres.",
                "array": "El {attribute} debe tener más que {value} artículos."
            },
            "gte": {
                "numeric": "El {attribute} debe ser mayor o igual que {value}.",
                "file": "El {attribute} debe ser mayor o igual que {value} kilobytes.",
                "string": "El {attribute} debe ser mayor o igual que {value} caracteres.",
                "array": "El {attribute} debe tener {value} artículos o más."
            },
            "image": "La {attribute} debe ser una imagen.",
            "in": "El seleccionado {attribute} no es válido.",
            "in_array": "El {attribute} campo no existe en {other}.",
            "integer": "El {attribute} debe ser un entero.",
            "ip": "La {attribute} debe ser una dirección IP válida.",
            "ipv4": "La {attribute} debe ser una dirección IPv4 válida.",
            "ipv6": "La {attribute} debe ser una dirección IPv6 válida.",
            "json": "La {attribute} debe ser una cadena JSON válida.",
            "lt": {
                "numeric": "El {attribute} debe ser menor que {value}.",
                "file": "El {attribute} debe ser menor que {value} kilobytes.",
                "string": "El {attribute} debe ser menor que {value} caracteres.",
                "array": "El {attribute} debe tener menos que {value} artículos."
            },
            "lte": {
                "numeric": "El {attribute} debe ser menor o igual {value}.",
                "file": "El {attribute} debe ser menor o igual {value} kilobytes.",
                "string": "El {attribute} debe ser menor o igual {value} caracteres.",
                "array": "El {attribute} no debe tener más de {value} artículos."
            },
            "max": {
                "numeric": "El {attribute} no puede ser mayor que {max}.",
                "file": "El {attribute} no puede ser mayor que {max} kilobytes.",
                "string": "El {attribute} no puede ser mayor que {max} caracteres.",
                "array": "El {attribute} no puede tener más de {max} artículos."
            },
            "mimes": "El {attribute} must be a file of type: {values}.",
            "mimetypes": "Los {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "El campo {attribute} debe ser al menos de {min}.",
                "file": "El campo {attribute} debe ser al menos de {min} kilobytes.",
                "string": "El campo {attribute} debe ser al menos de {min} caracteres.",
                "array": "El campo {attribute} debe tener al menos {min} artículos."
            },
            "not_in": "El seleccionado {attribute} no es válido.",
            "not_regex": "El {attribute} formato no es válido.",
            "numeric": "El campo {attribute} tiene que ser un número.",
            "present": "El campo {attribute} debe estar presente.",
            "regex": "El campo {attribute} formato no es válido.",
            "required": "El campo {attribute} es requerido.",
            "required_if": "El campo {attribute} es requerido cuando {other} es {value}.",
            "required_unless": "El campo {attribute} es requerido a menos que {other} es en {values}.",
            "required_with": "El campo {attribute} es requerido cuando {values} esta presente.",
            "required_with_all": "El campo {attribute} es requerido cuando {values} esta presente.",
            "required_without": "El campo {attribute} es requerido cuando {values} no esta presente.",
            "required_without_all": "El campo {attribute} es requerido cuando ninguno de {values} estan presentes.",
            "same": "El campo {attribute} debe coincidir con {other}.",
            "size": {
                "numeric": "El {attribute} debe ser {size}.",
                "file": "El {attribute} debe ser {size} kilobytes.",
                "string": "El {attribute} debe ser {size} caracteres.",
                "array": "El {attribute} debe contener {size} artículos."
            },
            "string": "El {attribute} debe ser un texto.",
            "timezone": "El {attribute} debe ser una zona válida.",
            "unique": "El {attribute} ya se ha tomado.",
            "uploaded": "El {attribute} no se pudo cargar.",
            "url": "El {attribute} formato no válido.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "attributes": {
                "work_places": "lugares de trabajo",
                "daily_medicines": "medicamento diario",
                "medical_services": "servicio medico",
                "previous_illnesses": "enfermedades previas",
                "username": "nombre de usuario",
                "password": "contraseña",
                "phone_number": "número de telefono"
            }
        },
        "verification": {
            "title": "Verifica tu correo electrónico",
            "check_email": "Necesitamos verificar tu dirección de email",
            "check_email_label": "Consulta el correo electrónico para finalizar el registro. Te hemos enviado un enlace de registro a la dirección:",
            "resend_email": "¿No has recibido el enlace de registro? Volver a enviarlo",
            "resend_succesfully": "Reenviado satisfactoriamente",
            "reset_email": "Cambiar dirección de correo electrónico",
            "already_phone_exist": "El teléfono ya esta registrado",
            "send_code_succesfully": "Te hemos enviado un código de verificación a tu teléfono",
            "code_failed": "Código de verificación incorrecto",
            "already_verified": "Tu teléfono ya fue verificado",
            "success": "Tu teléfono se verifico correctamente!",
            "This is your verification code. {code}.": "Este es tu código de verificación. {code}.",
            "The code your provided is wrong. Please try again or request another code.": "El código que proporcionó es incorrecto. Por favor intente nuevamente o solicite otro código.",
            "Your phone has not been verified yet": "Su teléfono no ha sido verificado aún",
            "Your phone was successfully verified!": "Su teléfono fue verificado con éxito!",
            "Your code has been resent successfully.": "Su código ha sido reenviado exitosamente."
        },
        "welcome": {
            "subject": "Bienvenido a Controlla",
            "line_1": "Bienvenido.",
            "action": "Pruébalo ahora"
        }
    }
}
